import React from 'react';
import { Container, Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';
import config from 'react-global-configuration';

import {
  PARAGRAPH_VIEW_MODE_DEFAULT,
  PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME,
  DOMAIN_AMSTERDAMUNDERGROUND,
} from '../../../config/constants';

import './style.scss';

const ParagraphImage = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT, lazyload = true }) => {
  const image = entity.getIn(['field_image', 0, 'styles', 'image']);
  const originalScaledImage = entity.getIn(['field_image', 0, 'styles', 'scaled_original']);
  const caption = entity.getIn(['field_text', 0, 'processed'], '');
  const isFullWidth = entity.getIn(['field_full_width', 0, 'value'], false);
  const viewModeIsCampaignPageColorTheme = viewMode === PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME;
  const currentDomainIsAmsterdamUnderground = config.get('CURRENT_DOMAIN') === DOMAIN_AMSTERDAMUNDERGROUND;

  const paragraphClasses = c('ParagraphImage', {
    'full-width': isFullWidth,
  });
  const colClasses = c('col-12', {
    'col-md-10 offset-md-1': !currentDomainIsAmsterdamUnderground,
    'col-lg-8 offset-lg-2': !viewModeIsCampaignPageColorTheme && !currentDomainIsAmsterdamUnderground,
    'col-lg-7 offset-lg-0': viewModeIsCampaignPageColorTheme && !currentDomainIsAmsterdamUnderground,
  });

  return (
    <Container className={paragraphClasses}>
      <div className="row">
        <div className={colClasses}>
          <div className="ParagraphImage__image">
            <Image
              lazyload={lazyload}
              includeWebP
              src={isFullWidth ? originalScaledImage : image}
            />
            {caption && <WysiwygField className="ParagraphVideo__caption" html={caption} />}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphImage;
